import { SVGProps, Ref, forwardRef } from 'react';

export const MaxSquareGrayscaleSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <rect x={1} y={1} width={14} height={14} rx={2.92} fill="#919191" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.1 12.64c-.92 0-1.348-.134-2.092-.671-.47.604-1.96 1.076-2.025.268 0-.606-.134-1.119-.287-1.678-.181-.69-.387-1.458-.387-2.57 0-2.657 2.182-4.656 4.767-4.656 2.588 0 4.615 2.098 4.615 4.68a4.617 4.617 0 0 1-4.59 4.627m.039-7.01c-1.26-.065-2.24.806-2.458 2.171-.179 1.13.14 2.507.41 2.578.13.032.457-.232.661-.436.337.233.73.372 1.138.405a2.4 2.4 0 0 0 2.507-2.231A2.394 2.394 0 0 0 8.14 5.632z"
                fill="#E2E2E2"
            />
        </g>
    </svg>
));
MaxSquareGrayscaleSize16Glyph.displayName = 'MaxSquareGrayscaleSize16Glyph';
